// extracted by mini-css-extract-plugin
export default {"delete":"PhotoDelete_delete__X6t0c"};